module.exports = "<tr class=\"dijitReset\" role=\"separator\"\n\t><td colspan=\"4\" data-dojo-attach-point=\"containerNode\"\n\t></td\n></tr>\n"